import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "bg-slate-700 text-slate-100 -mx-2 h-full"
};
const _hoisted_2 = {
  class: "py-4"
};
const _hoisted_3 = {
  class: "text-3xl flex-center"
};
const _hoisted_4 = {
  class: "flex-center flex-col bg-slate-50 p-4 rounded-xl"
};
const _hoisted_5 = {
  class: "flex-center"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { app } from "@/di";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
import PlayerInfo from "@/modules/team/components/PlayerInfo.vue";
import { StaffMember } from "@/modules/staff/entity";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CareerEndedPage',
  async setup(__props) {
    let __temp, __restore;
    const members = ref();
    const route = useRoute();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      members.value = await StaffMember.createQueryBuilder('staffMember').innerJoinAndSelect('staffMember.team', 'team').where(`team.user = true AND staffMember.endsCareer = true`).getMany();
    })), __temp = await __temp, __restore(), __temp);
    const onContinue = async () => {
      app.get(GlobalResolver).resolvePromise();
    };
    return (_ctx, _cache) => {
      const _component_NCarouselItem = _resolveComponent("NCarouselItem");
      const _component_NCarousel = _resolveComponent("NCarousel");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-tabbar": "",
        "hide-footer": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('end_of_career')), 1)]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('x_staff_members_end_their_careers', {
          x: members.value.length
        })), 1)]),
        footerButtons: _withCtx(() => [_createVNode(_component_NButton, {
          type: "success",
          secondary: "",
          size: "large",
          onClick: onContinue,
          textContent: _toDisplayString(_ctx.$t('continue'))
        }, null, 8, ["textContent"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NCarousel, {
          "space-between": 30,
          loop: false,
          "slides-per-view": "auto",
          "centered-slides": "",
          class: "h-full",
          "show-arrow": "",
          "dot-type": "line"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (member, i) => {
            return _openBlock(), _createBlock(_component_NCarouselItem, {
              key: i,
              style: {
                width: `90%`
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString(member.constructor.name), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(member.name) + " (" + _toDisplayString(member.age) + ") ", 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(PlayerInfo, {
                class: "mr-2"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(Math.floor(member.skill)), 1)]),
                _: 2
              }, 1024)])]), _createVNode(FormGroup, {
                label: _ctx.$t('wage'),
                "value-width-ratio": .5
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$moneyPerMonth(member.wage)), 1)]),
                _: 2
              }, 1032, ["label"]), _createVNode(FormGroup, {
                label: _ctx.$t('market_value'),
                "value-width-ratio": .5
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(member.marketValue)), 1)]),
                _: 2
              }, 1032, ["label"])])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});